import { Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
//import * as FileSaver from 'file-saver';
import { saveAs } from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import constant from '../../../../../src/app/app.constant';
import { UploadImageService } from '../../../../../src/app/service/uploadImage';
import { CommonHttpService } from '../../../../../src/app/utils/common-http.service';
import commonLogics from '../../../../../src/app/utils/common-logic.service';
import { LocalStorageService } from '../../../../../src/app/utils/local-storage.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-issue-model',
  templateUrl: './issue-model.component.html',
  styleUrls: ['./issue-model.component.scss'],
  standalone: true,
  imports: [NgSelectModule, ReactiveFormsModule, CommonModule, NgbModule, TranslateModule]
})
export class IssueModelComponent implements OnInit {
  @ViewChild('fileUploadWrapper1', { static: false }) fileUploadWrapper1!: ElementRef;
  @ViewChild('fileUploadWrapper2', { static: false }) fileUploadWrapper2!: ElementRef;
  @ViewChild('fileUploadWrapper3', { static: false }) fileUploadWrapper3!: ElementRef;
  @ViewChild('fileUploadWrapper4', { static: false }) fileUploadWrapper4!: ElementRef;
  public constant: any = constant;
  public commonLogics: any = commonLogics;
  issueForm: FormGroup;
  fileUrl: any;
  fileUrl1: any;
  fileUrl2: any;
  fileUrl3: any;
  fileUrl4: any;
  fileName: any;
  fileName2: any;
  fileName1: any;
  fileName3: any;
  fileName4: any;
  issueList: any;
  comment_id: any;
  order_id: any;
  requireImg: boolean = false;
  submitted: boolean = false;
  dataNullCheck: boolean= false;
 created_user_id: any = null;

  constructor(private http: CommonHttpService, public activeModal: NgbActiveModal, public localData: LocalStorageService, private imageUpload: UploadImageService, private _formBuilder: FormBuilder, private toaster: ToastrService, private renderer: Renderer2) { }
  @Input() orderData: any;

  ngOnInit() {
    this.getIssueList();
    if (this.orderData) {
      this.getIssueOrderDetails();
    }
    this.issueForm = this._formBuilder.group({
      order_id: [null],
      reason: [null, Validators.required],
      cus_refunded_status: [null],
      user_comment: [null],
      support_comment: [null],
      refund_approval: [false],
      refund_status_to_cus: [null],
      refund_status_from_partner: [null],
      order_price: [null, Validators.pattern(/^\d+(\.\d{1,2})?$/)],
      doc1: [null],
      doc2: [null],
      doc3: [null],
      doc4: [null],
      doc5: [null],
    })
  }

  getIssueList() {
    this.http.get(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.Dynamic.getAll, { headers: { modelname: 'labelMaster' } }).subscribe((reponse: any) => {
      this.issueList = reponse.data;
    });
  }
  getIssueOrderDetails() {
    var reqData = { order_id: this.orderData.orderId, }
    this.http.postData(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.Order.IssueCommentGetById, reqData).subscribe((response: any) => {
      if (response.status) {
        this.dataNullCheck = response.data == null ? true : false;
         this.created_user_id = response.data == null ? null : response?.data?.created_user_id;
         if(!this.dataNullCheck){
            this.issueForm.controls['reason'].disable();
            if(response?.data?.order_price=="" || response?.data?.order_price==null){
              this.issueForm.controls['order_price'].enable();
            }else{
              this.issueForm.controls['order_price'].disable();
            }
          
           };

          if(!this.dataNullCheck && this.localData.getItem(constant.localStorage.user_id) != this.created_user_id){
            this.issueForm.controls['user_comment'].disable();
          }
          
        // this.toaster.success(response.message)
        if (response?.data?.refund_status_to_cus == 'Refunded') {
          this.issueForm.patchValue({
            cus_refunded_status: true,
          })
        } else if (response?.data?.refund_status_to_cus == 'Decline') {
          this.issueForm.patchValue({
            cus_refunded_status: false,
          })
        }
        this.issueForm.patchValue({
          order_id: (response?.data?.order_id) ? (response?.data?.order_id) : this.orderData.orderId,
          reason: response?.data?.reason,
          user_comment: response?.data?.user_comment,
          support_comment: response?.data?.support_comment,
          refund_approval: response?.data?.refund_approval,
          refund_status_to_cus: response?.data?.refund_status_to_cus,
          refund_status_from_partner: response?.data?.refund_status_from_partner,
          doc1: response?.data?.doc1,
          doc2: response?.data?.doc2,
          doc3: response?.data?.doc3,
          doc4: response?.data?.doc4,
          doc5: response?.data?.doc5,
          order_price: response?.data?.order_price
        })
        this.comment_id = response?.data?.comment_id;
        if (response?.data?.doc1) this.fileUrl = constant.ImageUrl.BaseUrl + constant.ImageUrl.Adloggs.ShowImage + response?.data?.doc1;
        if (response?.data?.doc2) this.fileUrl1 = constant.ImageUrl.BaseUrl + constant.ImageUrl.Adloggs.ShowImage + response?.data?.doc2;
        if (response?.data?.doc3) this.fileUrl2 = constant.ImageUrl.BaseUrl + constant.ImageUrl.Adloggs.ShowImage + response?.data?.doc3;
        if (response?.data?.doc4) this.fileUrl3 = constant.ImageUrl.BaseUrl + constant.ImageUrl.Adloggs.ShowImage + response?.data?.doc4;
        if (response?.data?.doc5) this.fileUrl4 = constant.ImageUrl.BaseUrl + constant.ImageUrl.Adloggs.ShowImage + response?.data?.doc5;
        this.fileName = response?.data?.doc1?.split('/').pop();
        this.fileName1 = response?.data?.doc2?.split('/').pop();
        this.fileName2 = response?.data?.doc3?.split('/').pop();
        this.fileName3 = response?.data?.doc4?.split('/').pop();
        this.fileName4 = response?.data?.doc5?.split('/').pop();

        if(!this.dataNullCheck && this.localData.getItem(constant.localStorage.user_id) != this.created_user_id){
          if(this.fileName!="" && this.fileUploadWrapper1?.nativeElement){
          this.renderer.addClass(this.fileUploadWrapper1.nativeElement,'disabled-upload');
          }
          if(this.fileName2!="" && this.fileUploadWrapper2?.nativeElement){
          this.renderer.addClass(this.fileUploadWrapper2.nativeElement,'disabled-upload');
          }
        };

        if(this.fileName2!="" && !commonLogics.roleCtrl([1, 2], 'checkRoleIsEqual') && this.fileUploadWrapper3?.nativeElement){
          this.renderer.addClass(this.fileUploadWrapper3?.nativeElement,'disabled-upload');
        }
        if(this.fileName3!="" && !commonLogics.roleCtrl([1, 2], 'checkRoleIsEqual') && this.fileUploadWrapper4?.nativeElement){
          this.renderer.addClass(this.fileUploadWrapper4?.nativeElement,'disabled-upload');
        }
      } else {
        // this.toaster.error(response.message)
        this.activeModal.close('dismiss');
        // this.modalService.open(this.issueContents, { centered: true });
      }
    });
  }
  closeModal() {
    this.activeModal.dismiss();
    this.requireImg = false;
  }
  //FileUpload
  async readUrlFile(event: any) {
    var data: any = { img_for: 'order', img_type: 'issue', img_name: 'doc1', first_id: this.order_id }
    this.fileName = event.target.files[0].name;
    var imageUrl: any = await this.imageUpload.imageUpload(event, data);
    if (!(imageUrl instanceof Error) && imageUrl.status) {
      this.fileUrl = constant.ImageUrl.BaseUrl + constant.ImageUrl.Adloggs.ShowImage + imageUrl.data;
    }
    this.issueForm.patchValue({
      doc1: imageUrl.data
    })
  }
  async readUrlFile1(event: any) {
    var data: any = { img_for: 'order', img_type: 'issue', img_name: 'doc2', first_id: this.order_id }
    this.fileName1 = event.target.files[0].name;
    var imageUrl: any = await this.imageUpload.imageUpload(event, data);
    if (!(imageUrl instanceof Error) && imageUrl.status) {
      this.fileUrl1 = constant.ImageUrl.BaseUrl + constant.ImageUrl.Adloggs.ShowImage + imageUrl.data;
    }
    this.issueForm.patchValue({
      doc2: imageUrl.data
    })
  }
  async readUrlFile2(event: any) {
    var data: any = { img_for: 'order', img_type: 'issue', img_name: 'doc3', first_id: this.order_id }
    this.fileName2 = event.target.files[0].name;
    var imageUrl: any = await this.imageUpload.imageUpload(event, data);
    if (!(imageUrl instanceof Error) && imageUrl.status) {
      this.fileUrl2 = constant.ImageUrl.BaseUrl + constant.ImageUrl.Adloggs.ShowImage + imageUrl.data;
    }
    this.issueForm.patchValue({
      doc3: imageUrl.data
    })
  }
  async readUrlFile3(event: any) {
    var data: any = { img_for: 'order', img_type: 'issue', img_name: 'doc4', first_id: this.order_id }
    this.fileName3 = event.target.files[0].name;
    var imageUrl: any = await this.imageUpload.imageUpload(event, data);
    if (!(imageUrl instanceof Error) && imageUrl.status) {
      this.fileUrl3 = constant.ImageUrl.BaseUrl + constant.ImageUrl.Adloggs.ShowImage + imageUrl.data;
    }
    this.issueForm.patchValue({
      doc4: imageUrl.data
    })
  }
  async readUrlFile4(event: any) {
    var data: any = { img_for: 'order', img_type: 'issue', img_name: 'doc5', first_id: this.order_id }
    this.fileName4 = event.target.files[0].name;
    var imageUrl: any = await this.imageUpload.imageUpload(event, data);
    if (!(imageUrl instanceof Error) && imageUrl.status) {
      this.fileUrl4 = constant.ImageUrl.BaseUrl + constant.ImageUrl.Adloggs.ShowImage + imageUrl.data;
    }
    this.issueForm.patchValue({
      doc5: imageUrl.data
    })
  }
  updateOrderissue() {
    this.submitted = true;
    if (this.issueForm.valid) {
      this.submitted = false;
      var reqData = { ...this.issueForm.value }
      if (reqData.doc1 || reqData.doc2 || (commonLogics.roleCtrl([1, 2], 'checkRoleIsEqual') && constant.swiggyId)) {
        if (commonLogics.roleCtrl([1, 2], 'checkRoleIsEqual')) {
          reqData.refund_approved_by = this.localData.getItem(constant.localStorage.user_id);
          reqData.refund_approved_dt = commonLogics.getCurrentDate();
        }
        if (commonLogics.roleCtrl([4, 5, 6, 10], 'checkRoleIsEqual')) {
          delete reqData.refund_approval;
          delete reqData.refund_status_from_partner
          delete reqData.refund_status_to_cus
          delete reqData.support_comment
        }

        if (!this.comment_id) {
          this.http.postData(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.Order.IssueComment, reqData).subscribe((response: any) => {
            if (response.status) {
              this.toaster.success(response.message);
              // this.modalService.dismissAll();
              this.requireImg = false;
              this.activeModal.close('dismiss');
            } else {
              this.toaster.error(response.message);
            }
          });
        } else {
          reqData.comment_id = this.comment_id;
          this.http.updateData(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.Order.IssueComment, reqData).subscribe((response: any) => {
            if (response.status) {
              this.toaster.success(response.message);
              // this.modalService.dismissAll();
              this.activeModal.close('dismiss');
            } else {
              this.toaster.error(response.message);
            }
          });
        }
      } else {
        return this.requireImg = true;
      }
    }

  }
  DownloadImage(item: any, name: any) {
    var laststring = item.substr(item.lastIndexOf('/') + 1);
    if (laststring != "img?url=null") {
      saveAs(item, name);
    } else {
      this.toaster.error("No Image")
    }
  }
  refundCusStatusChangeRefunded() {
    this.issueForm.patchValue({
      refund_status_to_cus: 'Refunded'
    });
  }
  refundCusStatusChangeDecline() {
    this.issueForm.patchValue({
      refund_status_to_cus: 'Decline'
    });
  }

restrictDecimal(event: KeyboardEvent) {
  const allowedKeys = ['Backspace','Tab','ArrowLeft','ArrowRight','Delete'  ];

  if (allowedKeys.includes(event.key)) {return;}

  const input = event.target as HTMLInputElement;
  const currentValue = input.value;
  const cursorPos = input.selectionStart ?? currentValue.length;

  const nextValue =currentValue.slice(0, cursorPos) +event.key +currentValue.slice(cursorPos);
  const regex = /^\d+(\.\d{0,2})?$/;

  if (!regex.test(nextValue)) {
    event.preventDefault();
  }
}



}
